module.exports = __webpack_public_path__ + "static/media/asc-bumper_selected.26625fc6.svg";